import React from "react";
import { Jumbotron, Button } from "reactstrap";
import "./Jumbotron.css";
import Bg from "../../images/dylan-gillis-533818-unsplash.jpg";

const Example = props => {
  var style = {
    paddingBottom: "50px",
    backgroundImage: "url(" + Bg + ")",
    position: "relative",
    height: "400px",
    paddingLeft: "0px",
    paddingRight: "0px",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover"
  };

  return (
    <div style={style}>
      <Jumbotron className="blueOverlay" style={{ color: "#fff" }}>
        {/* <div style={blueOverlay}> */}
        <h1 className="display-3">เพื่อนร่วมทางอีเว้นท์ของคุณ</h1>
        <p className="lead" style={{ margin: "10px 30px" }}>
          หาออแกไนเซอร์ที่คุณต้องการได้แล้วที่นี่!
        </p>

{/*        <p className="lead">
          <Button color="info" style={{ margin: "50px 20px" }}>
            Start hiring Organizer
          </Button>
        </p>
*/}
        <p className="bottom">Scroll down for more ↓</p>
        {/* </div> */}
      </Jumbotron>
    </div>
  );
};

export default Example;



// WEBPACK FOOTER //
// ./src/components/Jumbotron/Jumbotron.js